module.exports = __webpack_public_path__ + "img/Newsletter-Header-Logo.0647c415.png";